import React from 'react';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { StrapiImage } from '@/components/atoms';
import { LeadershipFragment } from '@/graphql/generated';

export const Card = ({ attributes }: LeadershipFragment) => {
  const { avatar, name, position } = attributes!;

  return (
    <Flex width="200px" flexDir="column" color="white">
      <Box width="200px" overflow="hidden">
        <StrapiImage image={avatar} style={{ objectFit: 'contain', maxHeight: '100%', height: '230px' }} />
      </Box>
      <Heading as="h3" variant="text-md/lineHeight-6/font-semibold" size="md" color="purple.500" mt={3}>
        {name}
      </Heading>
      <Text variant="text-sm/lineHeight-5/font-normal" size="sm" color="purple.500" mt={1}>
        {position}
      </Text>
    </Flex>
  );
};
